export default __webpack_public_path__ + "static/media/menu-icon-close.3295a21c.svg";